import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-background-50 text-lg`}></i>
              </div>
              <div>
                <h4 className="font-semibold text-foreground-900 text-sm font-heading">{cat.name}</h4>
                <p className="text-xs text-foreground-500 mt-0.5">最新爆料</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}